import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface SewersProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Sewers: React.FC<SewersProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [sewers, set_sewers] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Sewers'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Sewers': v } } })
    );
    const label = 'Sewers';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(sewers)}
                />
            ) : (
                <MoneyBox
                    id={'sewers'}
                    allowNegative={false}
                    value={sewers}
                    onChange={(value) => set_sewers(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
